import { AnalysisSignificance, TrendAnalysisResult } from "pokal_api"

function trendAnalysisToString(trend: TrendAnalysisResult): string {
    if (trend === null) return "Fehlende Daten"
    if (trend.difference === 0) return "Keine Veränderung"
    let result = ``
    switch (Number(trend.significance)) {
        case AnalysisSignificance.NOT_SIGNIFICANT:
            result += "Nicht signifikante "
            break
        case AnalysisSignificance.SIGNIFICANT:
            result += "Signifikante "
            break
        case AnalysisSignificance.VERY_SIGNIFICANT:
            result += "Sehr signifikante "
            break
        case AnalysisSignificance.EXTREMELY_SIGNIFICANT:
            result += "Extrem signifikante "
    }
    result += trend.improve ? "Verbesserung" : "Verschlechterung"
    return result
}

export default trendAnalysisToString
